import { combineReducers } from 'redux';

import domain from './domain';
import entities from './entities';

export default combineReducers({
  entities,
  domain,
});

export * from './entities';
export * from './actions';
export * from './domain';
export * from './selectors';
